(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("5ieyE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1007dac042f26a7f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $l3Muk = parcelRequire("l3Muk");

var $lj8Ba = parcelRequire("lj8Ba");

var $kqvgT = parcelRequire("kqvgT");
const $1007dac042f26a7f$var$PressReleases = ()=>{
    const { data: news, isLoading: isLoading } = (0, $l3Muk.default)();
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            !isLoading && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex flex-no-wrap md:mx-auto md:pt-4 md:pb-1 w-full overflow-x-auto lg:overflow-x-hidden lg:overflow-y-visible scroll-snap-x",
                children: /*#__PURE__*/ (0, $a9eYm.jsx)("ul", {
                    className: "flex md:justify-center gap-3 md:gap-6 mb-4 p-0",
                    children: news?.map((item)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $kqvgT.default), {
                            item: item,
                            customClasses: "w-full min-w-[280px] scroll-snap-align-start scroll-snap-stop-normal mdplus:scroll-margin-init mdplus:scroll-snap-align-init mdplus:scroll-snap-stop-init "
                        }, item?.title + item?.published))
                })
            }),
            isLoading && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex justify-center items-center py-16",
                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lj8Ba.default), {})
            })
        ]
    });
};
var $1007dac042f26a7f$export$2e2bcd8739ae039 = $1007dac042f26a7f$var$PressReleases;

});
parcelRegister("l3Muk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a05b0ea6b4a01cff$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $a05b0ea6b4a01cff$var$useTTNewsStartPage = ()=>{
    return (0, $4cyLg.useQuery)([
        "TTNews"
    ], ()=>(0, $1HGFx.TtService).ttGetTtNewsStartpage().then((response)=>response));
};
var $a05b0ea6b4a01cff$export$2e2bcd8739ae039 = $a05b0ea6b4a01cff$var$useTTNewsStartPage;

});

parcelRegister("kqvgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b522d03f9ad80376$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $N2wHE = parcelRequire("N2wHE");

var $l8eky = parcelRequire("l8eky");
const $b522d03f9ad80376$var$PressCard = ({ item: item, customClasses: customClasses })=>{
    const fallbackImage = "/Images/fallbacks/office1.jpg?mode=crop&quality=70&width=400&height=225";
    const toUrlSegment = (value)=>{
        if (!value) return "";
        const transformedValue = (0, $l8eky.letterTransform)(value.toLowerCase());
        const urlString = transformedValue.replace(/"|"/g, "").replace(/[^a-z0-9]/g, "-").replace(/-+/g, "-");
        return urlString;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE))).locale("sv");
    return /*#__PURE__*/ (0, $a9eYm.jsx)("li", {
        className: `w-full h-full list-none ${customClasses ? customClasses : ""}`,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
            className: "group block bg-white shadow-bs40 hover:shadow-bs60 rounded-md focus:outline focus:outline-2 focus:outline-blue-500 h-full overflow-hidden !transition-all textPressMessage",
            href: `/om-oss/press/pressmeddelanden/pressmeddelande/${toUrlSegment(item.title)}-${item?.id}/`,
            "aria-label": `L\xe4s pressmeddelande: ${item?.title}`,
            children: [
                (()=>{
                    if (item?.mainImage && item?.mainImage?.thumbnail_16_9) return /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        className: "w-full h-auto",
                        width: "400",
                        height: "225",
                        src: item?.mainImage?.thumbnail_16_9,
                        loading: "lazy",
                        alt: item?.mainImage?.title ? item?.mainImage?.title : ""
                    });
                    if (item?.images && item?.images?.length > 0 && item?.images[0].thumbnail_16_9) return /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        className: "w-full h-auto",
                        width: "400",
                        height: "225",
                        src: item?.images[0]?.thumbnail_16_9,
                        alt: item?.images[0].caption ? item?.images[0].caption : item?.images[0].title,
                        loading: "lazy"
                    });
                    else return /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        className: "w-full h-auto",
                        width: "400",
                        height: "225",
                        src: fallbackImage,
                        alt: "Generisk bild f\xf6r pressmeddelande",
                        loading: "lazy"
                    });
                })(),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "bg-white p-4 py-4 rounded-b-md text-black700",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "text-grey400 text-tiny",
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(item?.published).format("YYYY-MM-DD")
                        }),
                        item?.title && /*#__PURE__*/ (0, $a9eYm.jsx)("h4", {
                            className: "mt-1 mb-2 font-icb text-lg group-hover:underline line-clamp-3 text-pretty",
                            children: item?.title
                        }),
                        item?.leadTextOrBodyStrip && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                            className: "mb-0 line-clamp-3",
                            children: item?.leadTextOrBodyStrip
                        })
                    ]
                })
            ]
        })
    });
};
var $b522d03f9ad80376$export$2e2bcd8739ae039 = $b522d03f9ad80376$var$PressCard;

});


parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

})();
//# sourceMappingURL=PressReleases.3579e51e.js.map
